.list {
  max-width: 300px;
  padding: 4px;
  list-style: none;
  background: var(--gray-50);
  border: 1px solid var(--gray-400);
  border-radius: 4px;
}

.listItem {
  display: block;
  padding: 10px;
  margin: 0;
  overflow: hidden;
  font-size: var(--font-size-body-2);
  color: var(--gray-700);
  border-radius: 4px;
  transition: background-color 0.2s ease-out;

  &:hover {
    background-color: var(--surface);
  }
}

.alignContent {
  margin-right: -10px;
  margin-left: -10px;
}

.listHead {
  position: relative;
  margin-bottom: 4px;
  overflow: visible;
  border-bottom: 1px solid var(--gray-400);
  border-radius: 0;
  transition: border-color;

  &::after,
  &::before {
    position: absolute;
    bottom: -1px;
    left: -4px;
    width: 4px;
    content: "";
    border-bottom: 1px solid var(--gray-400);
  }

  &::after {
    right: -4px;
    left: auto;
  }

  &:hover {
    background-color: transparent;
  }
}

.active {
  font-weight: var(--font-weight-bold);
  color: var(--gray-900);
}

.passPadding {
  padding: 0;

  & > * {
    padding: 10px;
  }
}
